/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, ElementRef, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { StudentForEvaluator } from '@app/app/page-modules/admin/components/mentors/admin-mentors.model';
import {
  MENTOR_MENTEE_DATA_SERVICE,
  MentorMenteeDataService,
} from '@app/app/page-modules/admin/services/mentor-mentee/mentor-mentee-data.service';
import { UserInfo } from '@app/app/shared/models/analytics/analytics.model';

@Component({
  selector: 'ptl-student-search-autocomplete',
  templateUrl: './student-search-autocomplete.component.html',
  styleUrls: ['./student-search-autocomplete.component.scss'],
})
export class StudentSearchAutocompleteComponent {
  @Input() placeholder = 'Search student';
  @Input() evaluatorUserUid: string;

  @Output() memberSelected = new EventEmitter<UserInfo>();

  @ViewChild('searchInput') searchInputRef?: ElementRef<HTMLInputElement>;

  canLoadMore: boolean;
  isLoadingMore: boolean;
  showEmptyResultInfo: boolean;
  protected users: UserInfo[] = [];
  protected loading = false;
  private name = '';

  constructor(@Inject(MENTOR_MENTEE_DATA_SERVICE) private mentorMenteeService: MentorMenteeDataService) {}

  onTextPaste(event: ClipboardEvent) {
    setTimeout(() => {
      this.name = (event.target as HTMLInputElement).value;
      this.applyNameFilter();
    }, 0);
  }

  onSearchInputChange(event: KeyboardEvent) {
    const previousValue = this.name;
    const newValue = (event.target as HTMLInputElement).value.trim();

    if (previousValue !== newValue) {
      this.name = newValue;
      this.applyNameFilter();
    }
  }

  disabledAutocomplete(): string {
    return '';
  }

  onMemberSelected({ option }: MatAutocompleteSelectedEvent) {
    const data = option.value as UserInfo;
    this.memberSelected.emit(data);
  }

  onAutocompleteScroll() {
    if (!this.canLoadMore) {
      return;
    }
    if (!this.isLoadingMore) {
      this.isLoadingMore = true;
    }
  }

  applyNameFilter() {
    this.loading = true;

    this.mentorMenteeService.findStudentsForEvaluator(0, 100000, this.evaluatorUserUid, undefined, undefined, this.name).subscribe({
      next: (result) => {
        if (result.isSuccess) {
          this.users = result.value.content.map((student: StudentForEvaluator) => ({
            userId: student.id,
            imageUrl: student.imageUrl,
            firstName: student.firstName,
            lastName: student.lastName,
            email: student.email,
          }));
          this.showEmptyResultInfo = this.users.length === 0;
        } else {
          this.users = [];
        }
      },
      error: () => (this.users = []),
      complete: () => (this.loading = false),
    });
  }

  focusInput() {
    this.searchInputRef?.nativeElement.focus();
  }
}
